module.exports = __webpack_public_path__ + "img/worksbot_img19112524.20088968.jpg";